import PracticeView from './PracticeView';
import ProviderView from './ProviderView';
import { Props } from './common';

import * as api from '../../../api';
import _ from 'lodash';
import MultiView from './MultiView';

const ScheduleAppointment: React.FC<Props> = ({
  availableEhrTimeSlots,
  practices,
  providers,
  navigateToNextPage,
  onAppointmentSelected,
  practice,
  encounter,
  fieldConfig,
  patientOrder,
  mainProviderUserId,
  patientPcpPreferred,
  filterProps,
}) => {
  const scheduleAppointmentDisplayBy =
    fieldConfig.scheduleAppointmentDisplayBy ??
    api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy.Practice;
  switch (scheduleAppointmentDisplayBy) {
    case api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy
      .Practice:
      if (_.uniqBy(availableEhrTimeSlots, 'practiceId').length > 1) {
        return (
          <MultiView
            availableEhrTimeSlots={availableEhrTimeSlots}
            navigateToNextPage={navigateToNextPage}
            onAppointmentSelected={onAppointmentSelected}
            encounter={encounter}
            fieldConfig={fieldConfig}
            practices={practices}
            providers={providers}
            scheduleAppointmentDisplayBy={scheduleAppointmentDisplayBy}
          />
        );
      }
      return (
        <PracticeView
          availableEhrTimeSlots={availableEhrTimeSlots}
          practices={practices}
          providers={providers}
          navigateToNextPage={navigateToNextPage}
          onAppointmentSelected={onAppointmentSelected}
          practice={practice}
          encounter={encounter}
          fieldConfig={fieldConfig}
        />
      );
    case api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy
      .Provider:
      if (
        patientOrder?.alternateReferredToProvider ||
        _.uniqBy(availableEhrTimeSlots, 'providerId').length > 1
      ) {
        return (
          <MultiView
            availableEhrTimeSlots={availableEhrTimeSlots}
            navigateToNextPage={navigateToNextPage}
            onAppointmentSelected={onAppointmentSelected}
            encounter={encounter}
            fieldConfig={fieldConfig}
            practices={practices}
            providers={providers}
            scheduleAppointmentDisplayBy={scheduleAppointmentDisplayBy}
            patientOrder={patientOrder}
            mainProviderUserId={mainProviderUserId}
            patientPcpPreferred={patientPcpPreferred}
            filterProps={filterProps}
          />
        );
      }
      return (
        <ProviderView
          availableEhrTimeSlots={availableEhrTimeSlots}
          practices={practices}
          providers={providers}
          navigateToNextPage={navigateToNextPage}
          onAppointmentSelected={onAppointmentSelected}
          practice={practice}
          encounter={encounter}
          fieldConfig={fieldConfig}
        />
      );
    default:
      const s: never = scheduleAppointmentDisplayBy;
      void s;
      return null;
  }
};

export default ScheduleAppointment;
